import { Button, Colors, IcReplace, IcTrash } from 'basic-ui-lib';
import storeApis from 'modules/store/services/apis';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getMessageError } from 'services/response';
import styled from 'styled-components';
import toast from 'utils/toast';
import ModalConfirm, { useModalConfirmRef } from 'widgets/ModalConfirm';
import StoreInfo from '../StoreInfo';

const StoreInfoPanel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeName, phone, address, ownerName, totalScreen } = location.state || {};
  const modalConfirmRef = useModalConfirmRef();
  const { id } = useParams<{ id: string }>();

  const handleDelete = async (storeId: string) => {
    try {
      const res = await storeApis.deleteStore(storeId);
      if (res?.data?.data) {
        toast.success('Store deleted successfully');
        navigate(-1);
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Failed to delete store');
    }
  };

  const onDeleteStore = (storeId: string) => {
    modalConfirmRef.current?.open(() => handleDelete(storeId), {
      message: 'Are you sure you want to delete this store? This action cannot be undone.',
    });
  };

  return (
    <Container>
      <StoreInfo
        storeName={storeName}
        ownerName={ownerName}
        phone={phone}
        address={address}
        totalScreen={totalScreen}
      />

      <ActionsSection>
        <Button
          lg
          type_primary
          style={{ width: '100%' }}
          prefix={<IcReplace width={20} height={20} fill={Colors.neutral.bg[1]} />}
        >
          Edit Information
        </Button>
        <Button
          lg
          type_delete
          style={{ width: '100%' }}
          prefix={<IcTrash width={20} height={20} fill={Colors.other[3]} />}
          onClick={() => onDeleteStore(id || '')}
        >
          Delete
        </Button>
      </ActionsSection>

      <ModalConfirm ref={modalConfirmRef} />
    </Container>
  );
};

export default StoreInfoPanel;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  box-sizing: border-box;
`;

const ActionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px 24px;
  margin-top: auto;
  flex-shrink: 0;
`;
